<template>
	<ul class="main-navigation-menu">
		<li v-for="(menu_item, index) in menu_items.filter(x => Object.keys(x).includes('title'))" :key="menu_item.title" v-bind:class="hide_menu(menu_item)">
			<a href="javascript:void(0)" v-bind:class="level_0_class(index, menu_item)" @click="gotoPage(menu_item)">
				<div class="item-content">
					<div class="item-media">
						<div>
							<span class="fa fa-bars"></span>
						</div>
					</div>
					<div class="item-inner" style="display: flex; width: 207px; align-items: flex-start;">
						<span class="title" style="max-width: 150px;" v-bind:class="level_0_class(index, menu_item)"> {{ menu_item.title }} </span>
						<div v-if="bookmarks.indexOf(menu_item.page_index) != -1" class="bookmarked_page"><i class="glyphicon glyphicon-bookmark text-dark"></i></div>
						<div v-if="visited_pages.indexOf(menu_item.page_index) !== -1" class="visited_page"></div>
						<i v-if="hasSubMenu(menu_item)" class="icon-arrow"></i>
					</div>
				</div>
			</a>
			<ul v-if="hasSubMenu(menu_item)" class="sub-menu">
				<li v-for="(menu_item, index) in menu_item.menu_items.filter(x => Object.keys(x).includes('title'))" :key="menu_item.title" v-bind:class="hide_menu(menu_item)">
					<a href="javascript:;" style="display: flex;" v-bind:class="level_1_class(index, menu_item)" @click="gotoPage(menu_item)">

						<span style="white-space: normal; width: 135px;" v-bind:class="level_1_class(index, menu_item)">
							{{ menu_item.title }}
						</span>
						<div v-if="bookmarks.indexOf(menu_item.page_index) != -1" class="bookmarked_page"><i class="glyphicon glyphicon-bookmark text-dark"></i></div>
						<div v-if="visited_pages.indexOf(menu_item.page_index) !== -1" class="visited_page"></div>
						<i v-if="hasSubMenu(menu_item)" class="icon-arrow"></i>
					</a>
					<ul v-if="hasSubMenu(menu_item)" class="sub-menu">
						<li v-for="(menu_item, index) in menu_item.menu_items.filter(x => Object.keys(x).includes('title'))" :key="menu_item.title" v-bind:class="hide_menu(menu_item)">
							<a href="javascript:;" v-bind:class="level_2_class(index, menu_item)" @click="gotoPage(menu_item)">

								<span v-if="visited_pages.indexOf(menu_item.page_index) !== -1" v-bind:class="level_2_class(index, menu_item)">
									<!--<i v-if="bookmarks.indexOf(menu_item.page_index) != -1" class="glyphicon glyphicon-bookmark"></i>-->{{ menu_item.title }}
								</span>
								<span v-if="visited_pages.indexOf(menu_item.page_index) === -1" v-bind:class="level_2_class(index, menu_item)">
									<!--<i v-if="bookmarks.indexOf(menu_item.page_index) != -1" class="glyphicon glyphicon-bookmark"></i>-->{{ menu_item.title }}
								</span>
								<div v-if="bookmarks.indexOf(menu_item.page_index) != -1" class="bookmarked_page"><i class="glyphicon glyphicon-bookmark text-dark"></i></div>
								<div v-if="visited_pages.indexOf(menu_item.page_index) !== -1" class="visited_page"></div>
								<i v-if="hasSubMenu(menu_item)" class="icon-arrow"></i>
							</a>
							<ul v-if="hasSubMenu(menu_item)" class="sub-menu">
								<li v-for="(menu_item, index) in menu_item.menu_items.filter(x => Object.keys(x).includes('title'))" :key="menu_item.title" v-bind:class="hide_menu(menu_item)">

									<a v-if="visited_pages.indexOf(menu_item.page_index) !== -1" href="javascript:;" v-bind:class="level_3_class(index, menu_item)" @click="gotoPage(menu_item)">
										<!--<i v-if="bookmarks.indexOf(menu_item.page_index) != -1" class="glyphicon glyphicon-bookmark"></i>-->{{ menu_item.title }}
									</a>
									<a v-if="visited_pages.indexOf(menu_item.page_index) === -1" href="javascript:;" v-bind:class="level_3_class(index, menu_item)" @click="gotoPage(menu_item)">
										<!--<i v-if="bookmarks.indexOf(menu_item.page_index) != -1" class="glyphicon glyphicon-bookmark"></i>-->{{ menu_item.title }}
									</a>
									<div v-if="bookmarks.indexOf(menu_item.page_index) != -1" class="bookmarked_page"><i class="glyphicon glyphicon-bookmark text-dark"></i></div>
									<div v-if="visited_pages.indexOf(menu_item.page_index) !== -1" class="visited_page"></div>
								</li>
							</ul>
						</li>
					</ul>
				</li>
			</ul>
		</li>
	</ul>
</template>

<script>
	export default {
		name: 'Menu',
		props: {
			menu_items: {
				type: Array
			},
			level_0_index: { type: Number },
			level_1_index: { type: Number },
			level_2_index: { type: Number },
			level_3_index: { type: Number },
			actual_page: { type: Number },
			bookmarks: { type: Array },
			visited_pages: { type: Array },
		},
		mounted: function() {
			$(document).ready(function() {
				//$('.lettericon').letterIcon();
			});
		},
		methods: {
			hasSubMenu(menu_item) {
				return Object.keys(menu_item).includes('menu_items');
			},
			level_0_class(index, menu_item){ return {item_active: this.actual_page === menu_item.page_index}},
			level_1_class(index, menu_item){ return {item_active: this.actual_page === menu_item.page_index}},
			level_2_class(index, menu_item){ return {item_active: this.actual_page === menu_item.page_index}},
			level_3_class(index, menu_item){ return {item_active: this.actual_page === menu_item.page_index}},
			gotoPage(menu_item) {
				if(Object.keys(menu_item).includes('page_index')) {
					this.$emit('goToPage',menu_item.page_index);
				}
			},
			hide_menu(menu_item) {
				return {
					//hide: (Object.keys(menu_item).includes('is_hidden') && menu_item.is_hidden === true) || (!Object.keys(menu_item).includes('title'))
					hide: Object.keys(menu_item).includes('is_hidden') && menu_item.is_hidden === true
				}
			}
		}
	}
</script>
<style>
	.item_active {
		font-weight: bold !important;
	}

	.visited_page {
		width: 10px;
		height: 10px;
		border-radius: 50%;
		background-color: green;
		display: inline-block;
		position: absolute;
		right: 25px;
		margin-top: 3px;
	}

	.icon-arrow {
		top: 0 !important;
		margin-top: 10px !important;
	}

	.bookmarked_page {
		display: inline-block;
		position: absolute;
		right: 43px;
		margin-top: 2px;
		font-size: 12px;
	}

	ul.main-navigation-menu li:hover {
		background: #fff !important;
	}

	#sidebar > div nav > ul > li.open, #sidebar > div nav > ul > li { background-color: white !important; }
	#sidebar > div nav > ul > li.open, #sidebar > div nav > ul > li:open { background-color: white !important; }
	#sidebar > div nav > ul > li.open, #sidebar > div nav > ul > li:hover { background-color: white !important; }

	ul.main-navigation-menu {
		margin-left: 0 !important;
	}

	ul.main-navigation-menu span.title {
		white-space: normal;
	}
</style>